<app-title-bar titleText="i18n.base.set-password.header"></app-title-bar>
<div class="row">
  <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
    <app-set-password></app-set-password>
  </div>
</div>